<template>
  <v-card flat outlined class="mb-4">
    <v-card-title class="py-2 text-subtitle-2">
      Fieldsets
      <v-spacer />
      <v-btn x-small text color="primary" @click="addFieldset">
        <v-icon x-small left>mdi-plus</v-icon>
        Add Fieldset
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-simple-table v-if="fieldsets.length > 0" dense>
      <thead>
        <tr>
          <th style="width: 30%">Key</th>
          <th style="width: 30%">Label</th>
          <th style="width: 15%">Expanded</th>
          <th style="width: 15%">Depends On</th>
          <th style="width: 14%" />
        </tr>
      </thead>
      <tbody>
        <tr v-for="(fs, idx) in fieldsets" :key="fs._uid || idx">
          <td>
            <v-text-field
              :value="fs.key"
              dense
              hide-details
              class="my-1"
              @input="updateFieldset(idx, 'key', $event)"
            />
          </td>
          <td>
            <v-text-field
              :value="fs.label"
              dense
              hide-details
              class="my-1"
              @input="updateFieldset(idx, 'label', $event)"
            />
          </td>
          <td>
            <v-switch
              :input-value="fs.expanded !== false"
              dense
              hide-details
              class="mt-0"
              @change="updateFieldset(idx, 'expanded', !!$event)"
            />
          </td>
          <td>
            <v-select
              :value="fieldsetDependsField(fs)"
              :items="fieldOptions"
              dense
              hide-details
              clearable
              class="my-1"
              @input="updateFieldsetDependsOn(idx, $event)"
            />
          </td>
          <td class="text-right" style="white-space: nowrap;">
            <v-btn icon x-small :disabled="idx === 0" @click="moveFieldset(idx, -1)">
              <v-icon x-small>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn icon x-small :disabled="idx === fieldsets.length - 1" @click="moveFieldset(idx, 1)">
              <v-icon x-small>mdi-arrow-down</v-icon>
            </v-btn>
            <v-btn icon x-small color="error" @click="removeFieldset(idx)">
              <v-icon x-small>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-card-text v-else class="text-center grey--text py-2">
      No fieldsets defined. Fields will display without grouping.
    </v-card-text>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash'
import { createDefaultFieldset } from './schemaConstants'
import { makeUid } from './schemaUtils'

export default {
  props: {
    fieldsets: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    fieldOptions() {
      return this.fields
        .filter(f => f.key)
        .map(f => ({ text: f.label || f.key, value: f.key }))
    },
  },
  methods: {
    addFieldset() {
      const fs = createDefaultFieldset()
      fs._uid = makeUid()
      const updated = [...this.fieldsets, fs]
      this.$emit('update', updated)
    },
    moveFieldset(idx, direction) {
      const newIdx = idx + direction
      if (newIdx < 0 || newIdx >= this.fieldsets.length) {
        return
      }
      const updated = cloneDeep(this.fieldsets)
      const temp = updated[idx]
      updated[idx] = updated[newIdx]
      updated[newIdx] = temp
      this.$emit('update', updated)
    },
    removeFieldset(idx) {
      const updated = [...this.fieldsets]
      updated.splice(idx, 1)
      this.$emit('update', updated)
    },
    updateFieldset(idx, prop, value) {
      const updated = cloneDeep(this.fieldsets)
      updated[idx][prop] = value
      this.$emit('update', updated)
    },
    fieldsetDependsField(fs) {
      if (!fs.depends_on) {
        return null
      }
      const keys = Object.keys(fs.depends_on)
      return keys.length > 0 ? keys[0] : null
    },
    updateFieldsetDependsOn(idx, depField) {
      const updated = cloneDeep(this.fieldsets)
      if (!depField) {
        delete updated[idx].depends_on
      } else {
        updated[idx].depends_on = { [depField]: [] }
      }
      this.$emit('update', updated)
    },
  },
}
</script>
